import { utilsMixins } from '@/mixins/utils.mixins';
import { onMounted, onUnmounted, onUpdated, ref } from 'vue';

export const useStickyHeight = (selectors: string[], additionalOffset = 0) => {
  const stickyOffset = ref(0);

  onMounted(() => {
    window.addEventListener('resize', calculateStickyOffsetValue);
    calculateStickyOffsetValue();
  });

  onUpdated(() => {
    calculateStickyOffsetValue();
  });

  onUnmounted(() => {
    window.removeEventListener('resize', calculateStickyOffsetValue);
  });

  function calculateStickyOffsetValue() {
    stickyOffset.value = utilsMixins.calculateDivHeight(selectors, additionalOffset);
  }

  return stickyOffset;
};
